import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'Report/';

const getQuoteReport = async (id) => axiosInstance.get(`${ENDPOINTORIGIN}GetQuoteReport?id=${id}`, constants.REQUIRE_INTERCEPTORS);

const anotherReport = async (id) => axiosInstance.get(`${ENDPOINTORIGIN}GetQuoteReport?id=${id}`, constants.REQUIRE_INTERCEPTORS);

export {
  getQuoteReport,
  anotherReport
};